import { createFileRoute } from '@tanstack/react-router'
import { ContractsTimeline } from '../../../components/ContractsTimeline'

export const Route = createFileRoute('/$org/contracts/timeline')({
  component: ContractsTimelineRoute,
  validateSearch: (search: Record<string, unknown>) => ({
    contract_type_uid: search.contract_type_uid ? String(search.contract_type_uid) : undefined,
    status: search.status ? String(search.status) : undefined,
    q: search.q ? String(search.q) : undefined,
    asset_uid: search.asset_uid ? String(search.asset_uid) : undefined,
  }),
})

function ContractsTimelineRoute() {
  return <ContractsTimeline />
}
